import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { startstopLoading } from "../Redux/Reducers/globalSlice";
import { capitalize } from "../Utils/commonFiles";
import PaginationComponent from "../Components/Pagination";
import { toast } from "react-toastify";
import { Col, Row } from "react-bootstrap";
import { Decryptedid, Encryptedid } from "../Utils/bcrypt";
import { getChangeRequestList, updateChangeRequestStatus } from "../Redux/Actions/event";
import DeleteModal from "../Components/CommanModals/DeleteModal";
import { deleteRequest } from "../Redux/Actions/auth";

const STATUS_TABS = ["Pending", "Approved", "Declined"];

const pillStyle = (active) => ({
  padding: "6px 16px",
  borderRadius: "20px",
  border: active ? "1px solid #132027" : "1px solid #d1d0d4",
  background: active ? "#132027" : "#fff",
  color: active ? "#fff" : "#6e6b78",
  fontSize: "13px",
  fontWeight: "500",
  cursor: "pointer",
  transition: "all 0.15s ease",
});

export default function ClientRequestChanges() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const Id = id && Decryptedid(atob(id));
  const navigate = useNavigate()
  const location = useLocation();

  const requestedChanges = useSelector((e) => e.eventAuth.getChangeRequestList);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [reqToDelete, setReqToDelete] = useState(null);
  const [statusFilter, setStatusFilter] = useState("Pending");

  const totalEntries = requestedChanges?.total ?? 0;
  const entriesPerPage = 8;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);

  const handlePageChange = (page) => setCurrentPage(page)
  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  const Initialize = async () => {
    try {
      const params = new URLSearchParams(location.search);
      const searchQuery = params.get("search") || "";
      dispatch(startstopLoading(true));
      await Promise.all([
        dispatch(getChangeRequestList({ limit: 8, page: currentPage, search: searchQuery, status: statusFilter })),
      ]);
      dispatch(startstopLoading(false));
    } catch (error) {
      dispatch(startstopLoading(false));
      toast.error("Failed to load event data");
      console.error(error);
    }
  };

  useEffect(() => {
    Initialize();
  }, [currentPage, location.search, statusFilter]);

  const handleStatusTab = (status) => {
    setStatusFilter(status);
    setCurrentPage(0);
  };

  // Changing the status moves the request to that status's tab
  const handleStatusChange = (request, status) => {
    dispatch(updateChangeRequestStatus({ id: request?._id, status })).then((res) => {
      if (res?.payload?.statusCode == 200) {
        toast.success(`Request marked as ${status}`);
        // Step back a page if this was the last request on it
        if (requestedChanges?.list?.length === 1 && currentPage > 0) {
          setCurrentPage(currentPage - 1);
        } else {
          Initialize();
        }
      } else {
        toast.error(res?.payload?.message || "Failed to update status");
      }
    });
  };


  const handleOpenDeleteModal = (id) => {
    setReqToDelete(id);
    setShowDeleteModal(true);
  };

  const handleDeleteRequest = () => {
    dispatch(deleteRequest({ id: reqToDelete })).then((res) => {
      if (res?.payload?.statusCode == 200) {
        Initialize()
        toast.success("Deleted Successfully")
      } else {
        toast.error(res?.payload?.message)
      }
      handleCloseDeleteModal();
    })
  }

  const handleEventDetail = (data) => {
    navigate(`/events-details/${Encryptedid(data?.event?._id)}?clientId=${data?.client?._id}`);
  }


  return (
    <Layout>
      <Container fluid>
        <Row>
          <Col lg={12}>
            <div className="comn-table-title">
              <h3> Change Requests<span>({requestedChanges?.total})</span></h3>
              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                {STATUS_TABS.map((status) => (
                  <button
                    key={status}
                    style={pillStyle(statusFilter === status)}
                    onClick={() => handleStatusTab(status)}
                  >
                    {status}
                  </button>
                ))}
              </div>
            </div>
            <div className="filters">
              <div className="inner-filter-field">
                <div class="table-responsive">
                  <Table size="sm" className="table-cmn">
                    <thead>
                      <tr>
                        <th>
                          <div className="user-checkbox">Event Title</div>
                        </th>
                        <th>
                          <div className="user-checkbox">Client Name</div>
                        </th>
                        <th>
                          <div className="user-checkbox">Message</div>
                        </th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {requestedChanges?.list?.map((requestedChangesRes) => (
                        <tr>
                          <td>
                            <div className="first-user" style={{cursor: "pointer"}} onClick={() => handleEventDetail(requestedChangesRes)}>
                              <div className="user-profile">
                                {capitalize(requestedChangesRes?.event?.eventName)}
                              </div>
                            </div>
                          </td>

                          <td>
                            <div style={{cursor: "pointer"}} className="first-user"
                             onClick={() => navigate(`/client-detail/${Encryptedid(requestedChangesRes?.client?._id)}`)}>
                              <div className="user-profile">
                                {capitalize(requestedChangesRes?.client?.fullName)}
                              </div>
                            </div>
                          </td>

                          <td>
                            <div className="first-user">
                              <div className="user-profile">
                                {requestedChangesRes?.message}
                              </div>
                            </div>
                          </td>


                          <td>
                            <div className="mb-3 comp-pending-drop">
                              <select
                                value={requestedChangesRes?.status || "Pending"}
                                onChange={(e) => handleStatusChange(requestedChangesRes, e.target.value)}
                                className="form-control custom-select"
                              >
                                {STATUS_TABS.map((status) => (
                                  <option key={status} value={status}>{status}</option>
                                ))}
                              </select>
                            </div>
                          </td>

                          <td>
                            <div className="d-flex gap-2">
                              <div className="td-txt-bg" onClick={() => handleOpenDeleteModal(requestedChangesRes?._id)} style={{ cursor: "pointer" }}>Delete</div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {requestedChanges?.list?.length == 0 && (
                    <div className="song-requests-data">
                      <div className="no-data-found">
                        <p>No Data</p>
                      </div>
                    </div>
                  )}
                  {requestedChanges?.total > 1 && (
                    <PaginationComponent
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageChange}
                      totalEntries={totalEntries}
                      entriesPerPage={entriesPerPage}
                    />)}
                </div>
                <DeleteModal
                  show={showDeleteModal}
                  handleClose={handleCloseDeleteModal}
                  handleDelete={handleDeleteRequest}
                  name={"request"}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
}
